import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const PartnerView = ({ data, type, partnerId, setPartnerDetails, contacts }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [editedPartnerData, setEditedPartnerData] = useState(data);
    const [organisations, setOrganisation] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState(data?.product_item_details || []);
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [allProducts, setAllProducts] = useState([]);
    const didFetchRef = useRef(false);
    const [isProductModalOpen, setIsProductModalOpen] = useState(false);

    const fetchOrganisation = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: { Authorization: `Bearer ${token}` },

            });

            const data = response.data.data;

            setOrganisation(data);

        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };



    useEffect(() => {
        if (!didFetchRef.current) {
            fetchOrganisation();
            didFetchRef.current = true;
        }
    }, []);

    const getProbability = (stage) => {
        const probabilities = {
            suspect: 10,
            prospect: 25,
            approach: 50,
            negotiation: 75,
            "closed won": 90,
            "closed lost": 0,
            "closed dead": 0,
            order: 100,
        };
        return probabilities[stage] || 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newPartnerData = { ...editedPartnerData, [name]: value };

        if (name === 'stage') {
            const probability = getProbability(value);
            newPartnerData.probability = probability;
        }

        if (name === 'value' || name === 'stage') {
            const partnerValue = parseFloat(newPartnerData.value) || 0;
            const probability = parseFloat(newPartnerData.probability) || 0;
            newPartnerData.expected_revenue = ((partnerValue * probability) / 100).toFixed(2);
        }

        setEditedPartnerData(newPartnerData);
    };


    const handleSave = async () => {
        try {
            const dataToUpdate = { ...editedPartnerData };

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            console.log('Data sent to backend:', dataToUpdate);
            await axios.put(`${backendUrl}/api/partners/${partnerId}`, dataToUpdate, {
                headers: {
                    Authorization: `Bearer ${token}`,

                },
            });

            setPartnerDetails((prevDetails) => ({
                ...prevDetails,
                ...dataToUpdate, // Update only the changed fields
            }));



            setIsEditMode(false); // Exit edit mode after saving
        } catch (error) {
            console.error('Error saving client details:', error);
        }
    };


    // Define fields for dynamic rendering
    const fields = [
        { name: 'name', label: 'Name', type: 'text' },
        { name: 'organisation_id', label: 'Organisation Name', type: 'select', options: organisations.map(org => org.name) },
        { name: 'customer_type', label: 'Customer Type', type: 'select', options: ['existing customer', 'new customer'] },
        { name: 'lead_source', label: 'Lead Source', type: 'select', options: ['partner', 'consultant', 'inside sales', 'sales generated'] },

        { name: 'closed_date', label: 'Closed Date', type: 'date' },

        { name: 'stage', label: 'Stage', type: 'select', options: ['suspect', 'prospect', 'approach', 'negotiation', 'closed won', 'closed lost', 'closed dead', 'order'] },

        { name: 'value', label: 'Value', type: 'text' },
        { name: 'probability', label: 'Probability(%)', type: 'text' },
        { name: 'expected_revenue', label: 'Expected Revenue', type: 'text' },
        { name: 'next_steps', label: 'Next Step', type: 'text' },
        { name: 'remarks', label: 'Remarks', type: 'text' },
        { name: 'sales_cycle', label: 'Sales Cycle', type: 'text' },


    ];

    const visibleFields = fields.filter((field) => {
        if (field.name === "sales_cycle") {
            return true;
        }
        return isEditMode || editedPartnerData[field.name];
    });

    const rows = [];
    for (let i = 0; i < visibleFields.length; i += 3) {
        rows.push(visibleFields.slice(i, i + 3));
    }

    // Render each field dynamically
    const renderField = (field) => {
        if (field.name === 'organisation_id') {
            return (
                <select
                    className="form-control"
                    name={field.name}
                    value={editedPartnerData[field.name] || ''}
                    disabled={!isEditMode}
                    onChange={handleChange}
                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                >
                    <option value="">Select</option>

                    {organisations.map((org) => (
                        <option key={org.id} value={org.id}>
                            {org.name}
                        </option>
                    ))}
                </select>
            );
        }

        if (field.name === 'expected_revenue') {
            return (
                <input
                    className="form-control"
                    type="text"
                    name={field.name}
                    value={editedPartnerData[field.name] || ''}
                    readOnly
                    onChange={handleChange}
                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                />

            );
        }
        if (field.name === 'sales_cycle') {
            return (
                <input
                    className="form-control"
                    type="text"
                    name={field.name}
                    value={`${editedPartnerData[field.name]} days` || '0 days'}
                    readOnly
                    onChange={handleChange}
                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                />

            );
        }
        if (field.name === 'probability') {
            return (
                <input
                    className="form-control"
                    type="text"
                    name={field.name}
                    value={editedPartnerData[field.name] || 0}
                    readOnly
                    onChange={handleChange}
                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                />

            );
        }


        if (field.type === 'select') {
            return (
                <select
                    className="form-control"
                    name={field.name}
                    value={editedPartnerData[field.name] || ''}
                    disabled={!isEditMode}
                    onChange={handleChange}
                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                >
                    <option value="">Select</option>
                    {field.options.map((option, index) => (
                        <option key={index} value={option}>
                            {option.charAt(0).toUpperCase() + option.slice(1)}
                        </option>
                    ))}
                </select>
            );
        }

        return (
            <input
                className="form-control"
                type={field.type}
                name={field.name}
                value={editedPartnerData[field.name] || ''}
                readOnly={!isEditMode}
                onChange={handleChange}
                style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
            />
        );
    };

    return (
        <>
            <div className="page-details">
                <div className="card">
                    <div className="card-body">
                        <h4>Partner Details</h4><br/>

                        <div className="card">
                            <div className="card-body">
                                <form>
                                    {/* Dynamically render rows */}
                                    {rows.map((row, rowIndex) => (
                                        <div className="row" key={`row-${rowIndex}`}>
                                            {row.map((field) => {
                                                const fieldValue = editedPartnerData[field.name];
                                                // Only render fields that have a value (or in edit mode)
                                                if ((fieldValue || isEditMode)) {
                                                    return (
                                                        <div className="col-md-4 mb-3" key={field.name}>
                                                            <label className="col-form-label" style={{ fontSize: '13px' }}>
                                                                {field.label}
                                                            </label>
                                                            {renderField(field)}
                                                        </div>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </div>
                                    ))}

                                    {/* Save or Edit Buttons */}
                                    <div className="d-flex justify-content-end">
                                        {isEditMode ? (
                                            <button type="button" className="btn btn-secondary" onClick={handleSave}>
                                                Save
                                            </button>
                                        ) : (
                                            <button type="button" className="btn btn-secondary" onClick={() => setIsEditMode(true)}>
                                                Edit
                                            </button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div></div>


            </div>
           

        </>
    );
};

export default PartnerView;
